
import { Component, Vue, Watch, Prop, Ref, Emit } from "vue-property-decorator";
import { namespace, Getter, Action } from "vuex-class";
import { MobileFeatures } from "@/store/mobile/types";
import UploadFileButton from "@/components/mobile/dispatch/UploadFileButton.vue";
import * as api from "@/services/api.guardChat.service";
import ActiveUserList from "./ActiveUserList.vue";

const Mobile = namespace("mobile");

@Component({
	components: { UploadFileButton, ActiveUserList }
})

export default class ChatFunction extends Vue {

    @Mobile.Getter("getMobileFeatures") getMobileFeatures: MobileFeatures;

    @Prop() eventId: number;

    private message: string = "";
    private isUploading: boolean = false;
    private cancelUpload: boolean = false;
    private showActiveUserModal: boolean = false;
    private mentionedUsers: { fullName: string, userID: number }[] = [];

    private async sendMessage() {
        this.checkMessageForUserNames();
		const createMessageCommand = {
			eventId: this.eventId,
			messageType: "guard",
			message: this.message,
            mentionedUsers: this.mentionedUsers.map(x => x.userID)
		};
		await api.sendMessage(createMessageCommand);
        this.message = "";
        this.mentionedUsers = [];
	}

    private checkMessageForUserNames(){
        this.mentionedUsers = this.mentionedUsers.filter(u => this.message.includes(u.fullName));
    }

    private onIsUploading({ state }: { state: boolean }) {
        this.isUploading = state;
    }

    private onUploadSuccess() {
        this.isUploading = false;
    }

    @Watch("message")
    private onMessageUpdated(newValue: string) {
        if (newValue.endsWith("@")) {
            this.showActiveUserModal = true;
        }
    }

    public onActiveUserRowClick(clickedUser)
    {
        this.message = this.message + clickedUser.fullName;
        this.mentionedUsers.push(clickedUser);
        this.showActiveUserModal = false;
    }

    public onActiveUserHidden() {
        this.showActiveUserModal = false;
    }
}
